<template>
  <div>
    <div class="w3-container about-container">
      <h1 class="w3-xxxlarge"><b>{{ $t('About us') }}</b></h1>
      <hr class="w3-round">
      <div v-html="$t('About us text')"></div>
    </div>

    <div class="about-images-container">
      <div v-for="imageName in aboutImageNames">
        <img
          :src="`static/images/about_images/${imageName}`"
        />
      </div>
    </div>
  </div>
</template>

<i18n>
  {
    "de": {
      "About us": "Über uns",
      "About us text": "<p>Komplexe und einzigartige Lösungen, die Ihren Ansprüchen entsprechen.</p> <p>Unser Unternehmen bietet eine vollständige Lösung von der Planung bis zur Ausführung.<br>Damit entlasten wir Sie. Alles, wovon Sie geträumt haben, wird nach Ihren Vorstellungen durchgeführt.<br>Wir erstellen einzigartig entworfene, miteinander harmonisierende und kreative Oberflächen.<br>Unser Team wurde im Laufe der Jahre sorgfältig aus hochqualifizierten und erfahrenen Fachleuten zusammengestellt, so dass wir alle Aufgaben von der Planung bis zur Ausführung selbst erledigen.<br>Auch dem Zuhause wird heutzutage viel Aufmerksamkeit geschenkt, wenn es um die Verwendung von Glas geht, sei es eine Wohnung oder ein Haus, sei es drinnen oder draußen.<br>Die Verwendung des Glases bietet eine breite Palette von Lösungen, von den einfachsten Oberflächen bis zu den extremen Optionen. <br>Einfach und großartig.</p>"
    },
    "en": {
      "About us": "About us",
      "About us text": "<p>Complex and individual solutions, in compliance with your demands!</p> <p>Our company provides a complete solution from designing to implementation.<br> With this we carry burden for you. It is going to be implemented according to your idea, in which you were dreaming of.<br> We create uniquely designed, creative surfaces that complement each other.<br> We built up our team mindfully, from highly educated professionals with an abundance of experience throughout the years, so we carry out every range of duties, from designing to implementation.<br> Homes are getting a lot of attention these days, as well, if it's about glass.<br> Regardless if it's used in the apartment or in the house, inside or outside.<br> It's application provides several solutions, from the simplest to the most extreme surfaces. Simply and greatly.</p>"
    },
    "hu": {
      "About us": "Rólunk",
      "About us text": "<p>Komplex és egyedi megoldások az Ön igényeire szabva!</p> <p>Cégünk teljes körű megoldást nyújt a tervezéstől a kivitelezésig. <br> Ezzel vesszük le az Ön válláról a terhet, elképzelése szerint valósul meg, amit megálmodott. Egyedileg tervezett, egymással összhangban álló kreatív felületet alakítunk ki.<br>Csapatunkat az évek során gondosan, magasan képzett és nagy tapasztalattal rendelkező szakemberekből állítottuk össze, így minden feladatkört mi végzünk, a tervezéstől egészen a kivitelezésig.<br> Napjainkban az otthon is hasonlóan nagy figyelmet kapott, ha üvegről van szó, legyen az lakás vagy ház, beltéri vagy kültéri alkalmazása.<br> Rengeteg megoldást kínál a felhasználása, legegyszerűbb felületektől egészen az extrém megoldásokig. Egyszerűen, nagyszerűen.</p>"
    }
  }
</i18n>

<script>
  const aboutImageNames = require.context('static/images/about_images', false, /\.(jpg)$/).keys();

  export default {
    name: 'aboutContent',
    data() {
      return {
        aboutImageNames,
      };
    },
    computed: {
      locale() {
        return this.$store.state.i18n.locale;
      },
    },
  };

</script>


<style scoped>
  hr {
    width: 50px;
    border: 5px solid;
    color: #eb2e4a !important;
    margin-top: 0px;
  }

  .about-container {
    margin-top: 75px;
    max-width: 1000px;
  }

  .about-images-container {
    max-width: 1000px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .about-images-container div {
    max-width: 50%;
  }

  .about-images-container img {
    width: 100%;
    padding: 5px;
  }
 </style>



// WEBPACK FOOTER //
// AboutContent.vue?507a9baa